import { render, staticRenderFns } from "./quesSuccess22.vue?vue&type=template&id=64295b0e"
import script from "./quesSuccess22.vue?vue&type=script&lang=js"
export * from "./quesSuccess22.vue?vue&type=script&lang=js"
import style0 from "./quesSuccess22.vue?vue&type=style&index=0&id=64295b0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports